import { render } from "./SetTagsModal.vue?vue&type=template&id=42372f5c"
import script from "./SetTagsModal.vue?vue&type=script&lang=js"
export * from "./SetTagsModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__